import { Component, Input, OnInit } from '@angular/core';
import { WatcherService } from 'src/app/services/watcher.service';
import { MatDialog } from '@angular/material/dialog';
import { YTPlayerDialog } from 'src/app/shared/features/yt-player-dialog/yt-player-dialog';
import { ShopAndShipService, ShopAndShipCountryContent, ShopAndShipCountry } from '../../services/shop-and-ship.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'lp-countries-hero',
  templateUrl: './hero-jumbotron.component.html',
  styleUrls: ['./hero-jumbotron.component.css'],
})
export class ShopAndShipHeroComponent implements OnInit {

  @Input() fromCountryName: string;
  @Input() toCountryName: string;


  fromCountryDetail!: ShopAndShipCountry;




  @Input() countryName: string;
  countriesList: ShopAndShipCountry[];
  showCountrySelection: boolean = false;
  lang: string;
  activeCountry: ShopAndShipCountry;
  constructor(
    private watcherService: WatcherService,
    public dialog: MatDialog,
    private _route: ActivatedRoute,
    private _router: Router,
    private _ShopAndShipService: ShopAndShipService
  ) {
    this.countriesList = this._ShopAndShipService.getCountries();
  }

  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    })
    this.activeCountry = this.countriesList.find(
      (country) => country.country_route === this.toCountryName
    );
    this.fromCountryDetail = this.countriesList.find(
      (country) => country.country_route === this.fromCountryName
    );
  }

  setActiveCountry(country: ShopAndShipCountry): void {
    this.activeCountry = country; 
    this._router.navigateByUrl(`/${this.lang}/shop-and-ship/from-${this.fromCountryDetail.country_route}/to-${country.country_route}`, { skipLocationChange: false })
  }

  openYTVideoDialog(): void {
    const videoData = {
      video_url:
        'https://www.youtube.com/embed/s3JGFhPmuN8?autoplay=1&rel=0',
      title: 'How to Shop from Amazon US to Australia',
      description: 'Description',
      thumbnail: '../assets/img/homepage/influencer-videos/inf-6.webp',
    }
      const dialogRef = this.dialog.open(YTPlayerDialog, { data: videoData });
    }
}
